import { testimonials } from "@/mocks/comicHelp";

const principles = [
  { icon: "ri-lightbulb-line", title: "内容丰富", text: "覆盖国漫、日漫、韩漫等多种题材，持续收录优质作品，满足不同口味。" },
  { icon: "ri-speed-line", title: "阅读顺畅", text: "持续优化线路与换源体验，让加载更快、翻页更稳，专注沉浸阅读。" },
  { icon: "ri-heart-line", title: "以读者为先", text: "把读者的使用体验放在首位，及时响应反馈，持续改进产品功能。" },
  { icon: "ri-shield-check-line", title: "数据安全", text: "严格保护账号与收藏数据，鼓励良性互动，营造健康阅读社区。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="container-x">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
              <i className="ri-user-heart-line"></i>
              关于笔笔漫画网
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
              陪你一起追更的阅读伙伴
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              笔笔漫画网是一个专注漫画阅读的在线平台，致力于为读者提供丰富、稳定、流畅的追漫体验。我们深知每一次点击、每一张图片加载、每一次换源都会直接影响阅读心情，因此从资源收录到线路优化，都围绕“顺畅好用”这一目标持续打磨。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-700">
              无论你是刚入门的新读者，还是阅漫无数的老书迷，我们都希望这里能成为你追更路上的可靠陪伴。你遇到的问题，就是我们改进的方向。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-900">
                    <i className={`${p.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 text-base font-semibold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700">{p.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-between gap-6">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-2">
                <i className="ri-star-fill text-accent-400"></i>
                <i className="ri-star-fill text-accent-400"></i>
                <i className="ri-star-fill text-accent-400"></i>
                <i className="ri-star-fill text-accent-400"></i>
                <i className="ri-star-fill text-accent-400"></i>
                <span className="ml-2 text-sm font-medium text-foreground-700">读者口碑</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                来自不同阅读偏好的读者，都对搜索、换源、收藏和阅读流畅度给出了真实反馈，你的体验同样值得被认真对待。
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-1 text-accent-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-primary-700">
                      {t.name.charAt(0)}
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                      <span className="block text-xs text-foreground-600">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}